import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  // Avatar,
  Grid,
} from "@mui/material";
import axios from 'axios';
import { Editor } from "@tinymce/tinymce-react";

import MailingListSelector from "./MailingListSelector.js";
// At top (add to your imports)
import CircularProgress from '@mui/material/CircularProgress';
import { productDict, productLogo } from "../constants/products";

const API_BASE_URL = process.env.REACT_APP_FASTAPI_URL;
const REACT_BASE_URL = process.env.REACT_APP_REDIRECT_URI;



function DripCampaignEmailGenerator() {
  const [selectedProductKey, setSelectedProductKey] = useState("");
  const [extraPrompt, setExtraPrompt] = useState("");
    const [step, setStep] = useState(1);

  // Initial inputs
  const [selectedProduct, setSelectedProduct] = useState("");
  const [, setProductUrl] = useState("");

  // Generated content state for step 2
  const [subject, setSubject] = useState("");
  const [preheader, setPreheader] = useState("");
  const [htmlBody, setHtmlBody] = useState("");
  const [templateName, setTemplateName] = useState("");

    const [selectedMailingListKey, setSelectedMailingListKey] = useState("");

    // Add state
const [loading, setLoading] = useState(false);

const [submitLoading, setSubmitLoading] = useState(false);
const [, setSubmitSuccess] = useState(false);

const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState('');

 
  const fetchTemplates = async () => {
    try {
      const response = await axios.post(`${API_BASE_URL}/emailgenerator/layouttemplates`, {});
      setTemplates(response.data.files || []);
    } catch (error) {
      alert("Failed to fetch templates: " + (error.response?.data?.detail || error.message));
    }
  };
  
  React.useEffect(() => {
    fetchTemplates();
  }, []);

const formatLabel = (filename) => {
  return filename
    .replace('_template.html', '') // Remove suffix
    .replace(/_/g, ' ')            // Replace underscores with spaces
    .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize each word
};
    
  // Simulate generate function, replace with actual API call
  const generateDripCampaignContent = async (productName, productUrl,productLogo) => {
   try {
    const response = await axios.post(
      `${API_BASE_URL}/emailgenerator/generateemail`,
      {
        product_name: productName,
        product_url: productUrl,
        product_logo: productLogo,
        extra_prompt: extraPrompt,
        selected_template: selectedTemplate,
      }
    );

    return response.data;
     } catch (error) {
    alert("Failed to generate campaign: " + (error.response?.data?.detail || error.message));
  }
  };
  const handleGenerate =  async () => {
    if (!selectedProductKey) {
      alert("Please select a product");
      return;
    }
   //alert(`Generating campaign for ${selectedProductKey} - URL: ${productDict[selectedProductKey]}`);
     
    setSelectedProduct(selectedProductKey);
    setProductUrl(productDict[selectedProductKey]);
     setLoading(true); // Start loader

    // Further logic here to generate campaign emails or to call your backend API
    try {
        // Call generate API or function
    const result = await generateDripCampaignContent(selectedProductKey, productDict[selectedProductKey],productLogo[selectedProductKey]);
    setSubject(result.subject);
    setPreheader(result.preheader);
    setHtmlBody(result.html_body);
    setTemplateName(result.template_name);
    setStep(2);
    } catch (error) {
    // Already handled in generateDripCampaignContent
    } finally {
      setLoading(false); // Stop loader
    }
  };

    const handleBack = () => setStep(1);
      const handleSubmit = async() => {
    // Submit final campaign data to backend or process further
    //alert("Campaign submitted:\n" + JSON.stringify({ subject, preheader, htmlBody }, null, 2));
     setSubmitLoading(true);
     setSubmitSuccess(false);
    try {
    const response = await axios.post(
      `${API_BASE_URL}/emailgenerator/createcampaign`,
      {
        product_name: selectedProduct,
        subject: subject,
        preheader: preheader,
        htmlBody: htmlBody,
        templateName: templateName,
        selectedMailingListKey: selectedMailingListKey,
      }
    );
    setSubmitSuccess(true);
    alert("Campaign created successfully!");
       // Go back to step 1 after success
    handleBack();
    return response.data;
     } catch (error) {
    alert("Failed to generate campaign: " + (error.response?.data?.detail || error.message));
  }finally {
    setSubmitLoading(false);
  }
  };

      const handleChange = (event) => {
    setSelectedTemplate(event.target.value);
    // You can trigger downstream logic here (e.g. load template content)
  };

  return (
    <Box p={2} sx={{minHeight:"80vh"}}>
      <Typography variant="h6" gutterBottom>
        DM Campaign Email Template Generator
      </Typography>

      
      {step === 1 && (
      <>
      <FormControl fullWidth margin="normal">
        <InputLabel id="select-product-label">Select Product</InputLabel>
        <Select
          labelId="select-product-label"
          value={selectedProductKey}
          label="Select Product"
          onChange={(e) => setSelectedProductKey(e.target.value)}
          renderValue={(selected) =>
            selected ? (
              <Grid container alignItems="center" spacing={1}>
                <Grid item>
                   <Box
                      component="img"
                      src={productLogo[selected]}
                      alt={selected}
                      sx={{ width: 124, height: 14, objectFit: "contain", display: "block" }}
                    />
                
                </Grid>
                <Grid item>{selected}</Grid>
              </Grid>
            ) : (
              ""
            )
          }
        >
          {Object.entries(productDict).map(([key, url]) => (
            <MenuItem key={key} value={key}>
              <Grid container alignItems="center" spacing={1}>
                <Grid item>
                 <Box
  component="img"
  src={productLogo[key]}
  alt={key}
  sx={{ width: 124, height: 14, objectFit: "contain", display: "block" }}
/>
                </Grid>
                <Grid item>{key}</Grid>
              </Grid>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
     
      <TextField
        fullWidth
        label="Extra Email Focus Prompt"
        multiline
        minRows={6}
        value={extraPrompt}
        onChange={(e) => setExtraPrompt(e.target.value)}
        margin="normal"
      />  
          <FormControl fullWidth>
      <InputLabel id="template-select-label">Select Template</InputLabel>
      <Select
        labelId="template-select-label"
        value={selectedTemplate}
        label="Select Template"
        onChange={handleChange}
      >
        {templates.map((template, index) => (
          <MenuItem key={template} value={template}>
            {formatLabel(template)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>

      <Button variant="contained" color="primary" onClick={handleGenerate} sx={{ mt: 2 }}  disabled={loading}>
       {loading ? <CircularProgress size={24} /> : "Generate Email Template"}
      </Button>
    
    </>
         )}
     {step === 2 && (
        <>
        <TextField
            fullWidth
            label="Campaign Template Name"
            value={templateName}
            onChange={(e) => setTemplateName(e.target.value)}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Email Subject"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            margin="normal"
          />

          <TextField
            fullWidth
            label="Email Preheader"
            value={preheader}
            onChange={(e) => setPreheader(e.target.value)}
            margin="normal"
          />

           <Editor
           license_key='gpl'
           tinymceScriptSrc={`${REACT_BASE_URL}/tinymce/tinymce.min.js`}  
        value={htmlBody}
        init={{
          height: 450,
          menubar: false,          
          toolbar:
            `undo redo | formatselect | bold italic backcolor | \
            alignleft aligncenter alignright alignjustify | \
            bullist numlist outdent indent | removeformat | help`,
          content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
        }}
        onEditorChange={(content) => setHtmlBody(content)}
      />
            <MailingListSelector onSelect={setSelectedMailingListKey} />


          <Box mt={2} display="flex" justifyContent="space-between">
            <Button variant="outlined" onClick={handleBack}>
              Back
            </Button>
            <Button variant="contained" color="primary" onClick={handleSubmit}  disabled={submitLoading}>
          {submitLoading ? <CircularProgress size={24} /> : "Create Campaign In Zoho"}            </Button>
          </Box>
        </>
      )}
  

    </Box>


    
  );
}

export default DripCampaignEmailGenerator;
